<template>
  <b-card>
    <div class="d-flex px-0 flex-wrap mb-1 align-items-center">
      <b-form-group
        label="فیلتر بر اساس"
        class="mb-1 col-md-3 col-sm-6 pr-md-2 pr-sm-50 px-0"
      >
        <select-box
          v-model="regarding_type"
          label="text"
          class="w-100"
          select="val"
          :lists="types"
          searchable
        />
      </b-form-group>
      <b-form-group
        v-if="regarding_type"
        class="mb-1 col-md-3 col-sm-6 pr-md-2 px-0"
        label="انتخاب شناسه"
      >
        <select-box
          v-model="regarding_id"
          label="text"
          class="w-100"
          select="id"
          :url="regarding_type"
          searchable
        />
      </b-form-group>
    </div>
    <div class="d-flex justify-content-between flex-wrap">
      <b-form class="d-flex align-items-center" @submit.prevent="onSearch">
        <b-form-input v-model.trim="search" />
        <b-button variant="primary" class="ml-sm-1 mt-sm-0 ml-50" type="submit">
          جستجو
        </b-button>
      </b-form>
      <div class="d-flex">
        <b-button class="my-1" variant="outline-danger" @click="removeComments">
          حذف موارد انتخاب شده
        </b-button>
      </div>
    </div>

    <data-table :fields="fields" :items="comments" :loading="loading">
      <template #selectuser="{ data }">
        <b-form-checkbox
          v-model="removeCommentsData"
          :value="data.item.id"
        ></b-form-checkbox>
      </template>
      <template #id="{ data }">
        {{ data.item.id }}
      </template>
      <template #user="{ data }">
        <span style="white-space: nowrap">
          {{ data.item.user.first_name + " " + data.item.user.last_name }}
        </span>
      </template>
      <template #regarding="{ data }">
        <div style="white-space: nowrap">
          {{ data.item.regarding.name }}
        </div>
      </template>
      <!-- <template #comment_at="{ data }">
        <b-badge variant="light-secondary">
          {{ calcDate(data.item.comment_at) }}
        </b-badge>
      </template> -->

      <template #status="{ data }">
        <b-badge :variant="data.item.status ? 'light-success' : 'light-danger'"
          >{{ data.item.status ? "فعال" : "غیر فعال" }}
        </b-badge></template
      >
      <template #actions="{ data }">
        <div class="d-flex justify-content-around">
          <b-button
            @click="showAnswerModal(data.item)"
            size="sm"
            variant="flat-primary"
            class="d-flex"
          >
            <feather-icon icon="TwitchIcon" />
            <div class="ml-50 text-truncate" style="width: 300px">
              {{ data.item.content }}
            </div>
          </b-button>

          <!-- <b-button
            size="sm"
            :variant="data.item.active ? 'flat-success' : 'flat-danger'"
          >
            <feather-icon :icon="data.item.active ? 'CheckIcon' : 'XIcon'" />
            <span class="ml-50">{{
              !data.item.active ? "تغییر به فعال" : " تغییر به غیر فعال"
            }}</span>
          </b-button> -->

          <b-button
            size="sm"
            variant="flat-danger"
            class="d-flex align-items-center"
            @click="removeComment(data.item)"
          >
            <feather-icon icon="TrashIcon" />
            <span class="ml-50">حذف</span>
          </b-button>
        </div>
      </template>
    </data-table>
    <b-modal
      id="modal-prevent-closing"
      ref="modal"
      v-model="visibleRes"
      hide-footer
      centered
      noCloseOnBackdrop
    >
      <validation-observer ref="addUserForm" #default="{ invalid }">
        <b-form class="auth-add-user-form my-2" @submit.prevent="sendComment">
          <div v-if="editMode">
            <b-form-group>
              <validation-provider
                #default="{ errors }"
                name="comment"
                vid="comment"
                rules="required"
              >
                <b-form-textarea
                  rows="4"
                  v-model="comment.content"
                  :state="errors.length > 0 ? false : null"
                />

                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </div>
          <div
            class="p-1 d-flex align-items-center justify-content-between"
            v-else
          >
            <div class="text-justify">
              {{ comment.content }}
            </div>
            <b-button
              variant="flat-secondary"
              size="sm"
              @click="editMode = true"
            >
              <feather-icon icon="EditIcon" />
            </b-button>
          </div>

          <b-form-group>
            <validation-provider
              #default="{ errors }"
              name="content"
              vid="content"
              rules="required"
            >
              <b-form-textarea
                rows="4"
                v-model="content"
                :state="errors.length > 0 ? false : null"
              />

              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>

          <b-button
            variant="primary"
            block
            type="submit"
            class="my-1"
            :disabled="invalid"
          >
            ثبت پاسخ
          </b-button>
        </b-form>
      </validation-observer>
    </b-modal>
    <div
      class="w-100 d-flex flex-wrap justify-content-between align-items-center"
    >
      <div class="col-md-3 pl-0">
        <b-form-checkbox v-model="selectAll" class="ml-2">
          انتخاب همه</b-form-checkbox
        >
      </div>
      <div class="col-md-6 d-flex justify-content-md-center align-items-center">
        <b-pagination
          v-model="currentPage"
          :total-rows="pagination.total"
          :per-page="pagination.per_page"
          size="md"
          class="my-2 d-flex justify-content-center"
        ></b-pagination>
      </div>
      <b-form
        @submit.prevent="goTo"
        class="d-flex col-md-3 align-items-center justify-content-md-end pr-0"
      >
        <div>
          <b-button type="submit" size="sm" variant="primary"
            >رفتن به
          </b-button>
        </div>
        <b-form-group label-for="to-page" class="w-50 ml-50 mb-0">
          <b-form-input
            id="to-page"
            type="number"
            size="sm"
            :max="pagination.total_pages"
            min="1"
            v-model="choosenPage"
          />
        </b-form-group>
      </b-form>
    </div>
  </b-card>
</template>
<script>
import {
  BButton,
  BModal,
  VBModal,
  BBadge,
  BPagination,
  BLink,
  BCard,
  BAvatar,
  BFormTextarea,
  BFormGroup,
  BFormCheckbox,
  BForm,
  BFormInput,
} from "bootstrap-vue";
import DataTable from "@/@core/components/data-table/DataTable.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import SelectBox from "@core/components/select-box/SelectBox.vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import qs from "qs";
export default {
  components: {
    DataTable,
    BButton,
    BModal,
    VBModal,
    BBadge,
    BPagination,
    BCard,
    BLink,
    BAvatar,
    BFormTextarea,
    ValidationProvider,
    ValidationObserver,
    BFormGroup,
    BFormCheckbox,
    BForm,
    BFormInput,
    SelectBox,
  },
  directives: {
    "b-modal": VBModal,
  },
  data() {
    return {
      editMode: false,
      types: [
        {
          id: 1,
          text: "دوره",
          val: "course",
        },
        {
          id: 2,
          text: "ترم",
          val: "semester",
        },
      ],
      choosenPage: 1,
      comments: [],
      loading: false,
      removeCommentsData: [],
      required,
      visible: false,
      visibleRes: false,
      content: "",
      search: "",
      selectAll: [],
      pagination: {},
      currentPage: 1,
      comment: {},
      fields: [
        { key: "selectuser", label: "" },

        { key: "id", label: "شناسه" },
        { key: "user", label: "کاربر" },
        { key: "regarding", label: "نظر مرتبط به" },
        // { key: "comment_at", label: "تاریخ" },
        { key: "status", label: "وضعیت" },
        { key: "actions", label: "عملیات" },
      ],
      regarding_type: "",
      regarding_id: "",
    };
  },
  computed: {
    selectedItems() {
      return {
        regarding_type: this.regarding_type,
        regarding_id: this.regarding_id,
      };
    },
  },
  watch: {
    selectedItems(val) {
      let filters = {};
      !val.regarding_type && (this.regarding_id = "");
      val.regarding_type &&
        val.regarding_id &&
        (filters.regarding = {
          type: val.regarding_type,
          id: val.regarding_id,
        });

      if (Object.keys(filters).length) {
        this.$router.push({
          name: "comments",
          query: {
            filters,
            key: this.$route.query.key,
          },
        });
      } else {
        this.$router.push({
          name: "comments",
          query: {
            key: this.$route.query.key,
          },
        });
      }
    },
    selectAll: {
      handler(val) {
        val
          ? (this.removeCommentsData = this.comments.map((user) => user.id))
          : (this.removeCommentsData = []);
      },
      immediate: true,
    },
    removeCommentsData: {
      handler(val) {
        val.length == this.comments.length && (this.selectAll = true);
        val.length == 0 && (this.selectAll = false);
      },
      deep: true,
    },
    $route: {
      handler(val) {
        this.removeCommentsData = [];
        this.getComments();
      },
      immediate: true,
      deep: true,
    },
    currentPage(val) {
      this.choosenPage = val;
      if (val != this.$route.query.page) {
        this.$router.push({
          name: "comments",
          query: {
            ...this.$route.query,
            page: val,
          },
        });
      }
    },
    search(val) {
      if (!val && this.$route.query.key) {
        this.$router.push({
          name: "comments",
        });
      }
    },
  },
  created() {
    if (this.$route.query.key || this.$route.query.filters) {
      this.$router.push({
        name: "comments",
      });
    }
  },
  methods: {
    goTo() {
      this.currentPage = this.choosenPage;
    },
    async onSearch() {
      if (this.search) {
        this.$router.push({
          name: "comments",
          query: {
            ...this.$route.query.filters,
            key: this.search,
          },
        });
      }
    },
    showAnswerModal(comment) {
      this.comment = comment;
      this.content =
        comment.children &&
        comment.children.data &&
        comment.children.data.length
          ? comment.children.data[0].content
          : "";
      this.editMode = false;
      this.visibleRes = true;
    },
    async sendComment() {
      this.loading = true;

      try {
        if (this.editMode) {
          await this.$http.put(`/panel/comments/${this.comment.id}`, {
            content: this.comment.content,
            status: this.comment.status,
          });
        }
        const { data } = await this.$http.post("/panel/comments", {
          regarding: {
            type: this.comment.regarding_type,
            id: this.comment.regarding_id,
          },
          parent_id: this.comment.id,
          content: this.content,
        });
        await this.getComments();
        this.visibleRes = false;
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "جواب با موفقیت ثبت شد",
            icon: "EditIcon",
            variant: "success",
          },
        });
      } catch (err) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "مشکلی پیش آمده است",
            icon: "EditIcon",
            variant: "warning",
          },
        });
      }
      this.loading = false;
    },
    removeComment(item) {
      this.$bvModal
        .msgBoxConfirm("آیا میخواهید این مورد حذف شود ؟", {
          size: "sm",
          bodyClass: "h5 my-2",
          okVariant: "primary",
          okTitle: "بله",
          cancelTitle: "خیر",
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then(async (value) => {
          if (value) {
            this.loading = true;
            try {
              await this.$http.delete(`/panel/comments/${item.id}`);
              if (!this.$route.query.page || this.$route.query.page == 1) {
                this.removeCommentsData = [];
                await this.getComments();
              } else {
                await this.$router.push({
                  name: "comments",
                  query: { page: 1 },
                });
                this.currentPage = await this.$route.query.page;
              }
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "مورد انتخاب شده با موفقیت حذف شد.",
                  icon: "EditIcon",
                  variant: "success",
                },
              });
            } catch (err) {}
            this.loading = false;
          }
        });
    },
    removeComments() {
      if (this.removeCommentsData.length) {
        this.$bvModal
          .msgBoxConfirm("آیا میخواهید موارد انتخاب شده حذف شوند ؟", {
            size: "sm",
            bodyClass: "h5 my-2",
            okVariant: "primary",
            okTitle: "بله",
            cancelTitle: "خیر",
            cancelVariant: "outline-secondary",
            hideHeaderClose: false,
            centered: true,
          })
          .then(async (value) => {
            if (value) {
              this.loading = true;
              try {
                await new Promise((resolve, reject) => {
                  this.removeCommentsData.map(async (comment, index) => {
                    await this.$http.delete(`/panel/comments/${comment}`);
                    if (index + 1 == this.removeCommentsData.length) {
                      resolve();
                    }
                  });
                });
                if (!this.$route.query.page || this.$route.query.page == 1) {
                  this.removeCommentsData = [];
                  await this.getComments();
                } else {
                  await this.$router.push({
                    name: "comments",
                    query: { page: 1 },
                  });
                  this.currentPage = await this.$route.query.page;
                }
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "موارد انتخاب شده با موفقیت حذف شدند.",
                    icon: "EditIcon",
                    variant: "success",
                  },
                });
              } catch (err) {}
              this.loading = false;
            }
          });
      } else {
        this.$toast(
          {
            component: ToastificationContent,
            props: {
              title: "موردی انتخاب نشده است",
              icon: "InfoIcon",
              variant: "danger",
            },
          },
          { position: "bottom-right" }
        );
      }
    },
    async getComments() {
      this.loading = true;
      try {
        const params = {
          per_page: 8,
          ...this.$route.query,
          includes: ["user", "comment", "children", "regarding"],
        };
        const { data } = await this.$http.get("/panel/comments", {
          params,
          paramsSerializer: (params) => {
            return qs.stringify(params);
          },
        });
        this.comments = data.data.comments;
        this.pagination = data.data.meta.pagination;
        this.currentPage = await this.pagination.current_page;
      } catch (err) {}
      this.loading = false;
    },
  },
};
</script>
<style>
.modal-header .close {
  margin: 0 !important;
}
</style>
